export default __webpack_public_path__ + "static/media/banner-down.f9dc1ab6.png";